export default __webpack_public_path__ + "static/media/construction-white.59a196f7.svg";